import isEmpty from 'lodash/isEmpty';

const windowUri = window.location.origin;

export const publicUrl = (path) => `${process.env.PUBLIC_URL || ''}${path}`;
export const API_BASE_URL = process.env.NODE_ENV === 'production' && isEmpty(process.env.REACT_APP_API_URL) ? windowUri : process.env.REACT_APP_API_URL;



// WEBPACK FOOTER //
// ./src/commons/uri.js